import React, { Component } from "react";
import { withSnackbar } from "notistack";
import { getInventoryListApi, deleteAssetDetailRow, EditTaskFormApi, fillEditFromApi, UpdateTaskFormApi, uploadFileApi, importFileApi, exportAssetDetailListApi, DownloadAllApi, exportMasterApi,bulkDelete,onArchiveAsset} from "../apiServices";
import { Box, Button, Grid, IconButton } from "@material-ui/core";
import InventorySearchBar from "../components/InventorySearchBar";
import InventoryTable from "../components/InventoryTable";
import { convertFilterObject, removeEmptyKey, permissionCheckFnforCamo, getLocalStorageInfo} from "../../../../utils";
import { inventoryTableHead } from "./InventoryTaskHead";
import { EmptyCollection, PageLoader, AccessDenied, DeletePopUp} from "../../../../shared_elements";
import InventoryList from "../components/InventoryList";
import BasicDetailHeader from "../../BasicDetailHeader";
import RefreshIcon from "@material-ui/icons/Refresh";
import PieChartOutlinedIcon from "@material-ui/icons/PieChartOutlined";
import { Link } from "react-router-dom";
import { Tooltip } from "@material-ui/core";
import { assetType } from "../../../../constants";
import FlightIcon from '@material-ui/icons/Flight';
import config from '../../../../config'
import DownloadXLSAssetDetail from "../../../../shared_elements/DownloadXLSAssetDetail";
import { trackActivity } from "../../../../utils/mixpanel";
import { smbcInstance } from "../../../../shared_elements/components";
class MainInventory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addFormDialog: false,
            sidebarOpen: true,
            tabIndex: 0,
            pageLoader: false,
            sort: "",
            sort_by: "",
            assetsDetail: {
                list: [],
                pagination: {},
                asset_count: {},
                new_task_last_used_folder_uuid: '',
                last_used_folder_uuid_link_document: "",
                checkbox_last_used_folder_uuid: "",
                checkbox_last_used_folder_name: ""
            },
            headerTsn: "",
            headerCsn: "",
            date_of_manufacture: "",
            currentRecordPerPage: 50,
            uuid: "",
            slug:'',
            basicDetails:{},
            bulkOperation: { modal: false, ids: [], title: '', type: '' },
            archiveModal:false
        };
        this.getInventoryListApi = getInventoryListApi.bind(this);
        this.openAddForm = this.openAddForm.bind(this);
        this.closeAddForm = this.closeAddForm.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.handleDeleteRow = deleteAssetDetailRow.bind(this);
        this.handleEditRow = fillEditFromApi.bind(this);
        this.UpdateTaskFormApi = UpdateTaskFormApi.bind(this);
        this.uploadFileApi = uploadFileApi.bind(this);
        this.importFileApi = importFileApi.bind(this);
        this.downloadAllApi = DownloadAllApi.bind(this);
        this.exportAssetDetailListApi = exportAssetDetailListApi.bind(this);
        this.exportMasterApi = exportMasterApi.bind(this);
        this.bulkDelete = bulkDelete.bind(this);
        this.onArchiveAsset = onArchiveAsset.bind(this);
        
    }

    componentDidMount() {
        this.getData();
        this.pullData();
        trackActivity('Inventory  Page Visited - CAMO', {
            event_type: 'Page Visited',
            page_title: 'Inventory',
        })
    }

    pullData = (slug,tsn, csn, date_of_manufacture) => {
        this.setState({ slug: slug });
        this.setState({ headerTsn: tsn });
        this.setState({ headerCsn: csn });
        this.setState({ date_of_manufacture: date_of_manufacture });
    };

    uuidData = (uuid) => {
        this.setState({ uuid: uuid });
    }
    getData(item) {
        this.getInventoryListApi( { per_page: this.state.currentRecordPerPage }, "skeletonLoader", this.props, item ? item : null );
    }

    openAddForm() {
        this.setState({ addFormDialog: true });
    }
    closeAddForm() {
        this.setState({ addFormDialog: false });
    }

    toggleSidebar() {
        this.setState({ sidebarOpen: !this.state.sidebarOpen });
    }
    createSortHandler = (sortField) => {
        if (sortField === "previous_taskCard") {
            sortField = "previous_LDND_Taskcard";
        } else if (sortField === "task_description") {
            sortField = "Task_Description";
        }

        const { sort, sort_by, filter, tabIndex, assetsDetail } = this.state;
        this.setState({
            sort: sortField,
            sort_by: sortField === sort ? (sort_by === "asc" ? "desc" : "asc") : "desc",
        })
        if (sortField === sort) {
            if (sort_by === "asc") {
                this.getInventoryListApi({ ...filter, sort: sortField, sort_by: "desc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
            } else {
                this.getInventoryListApi({ ...filter, sort: sortField, sort_by: "asc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
            }
        } else {
            this.getInventoryListApi({ ...filter, sort: sortField, sort_by: "asc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
        }
    };

    searchResults = (item) => {
        if (item !== null) {
            this.getData(item);
        }
    };

    updateFormData = async (updateId, updatedData, props,addform,closeform) => {
        await this.UpdateTaskFormApi(updateId, updatedData, props, this.state.currentRecordPerPage,addform,closeform)
    };

    fileUploadData = async (uploadId, formdata, props, haveAttachments) => {
        await this.uploadFileApi(uploadId, formdata, props, this.state.currentRecordPerPage, haveAttachments)
    };

    importFile = (formData, props, isXLSX) => {
        this.importFileApi(formData, props, isXLSX, this.state.currentRecordPerPage)
    }

    exportAssetDetailListFunc = (props) => {
        this.exportAssetDetailListApi(props);
    };

    downloadAllFilesApi = (props) => {
        this.downloadAllApi(props);
    };

    refreshComp = () => {
        this.getData();
    };
    toggleBulkOps = async (flag, type, item) => {
        const { bulkOperation, assetsDetail } = this.state;   
        try {
            if (type === 'bulk') {
                const response = await this.getInventoryListApi(
                    { per_page: assetsDetail?.pagination?.total},
                    "skeletonLoader",
                    this.props,
                    null
                );
                this.setState({
                    bulkOperation: { ...bulkOperation, type: 'bulk', ids: flag ? response?.data?.results : [] }
                });
            } else {
                this.setState({
                    bulkOperation: {
                        ...bulkOperation,
                        type: 'single',
                        ids: flag ? [...bulkOperation.ids, item] : bulkOperation.ids.filter(optionItem => optionItem.id !== item.id)
                    }
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
    engineType=(data)=>{
		this.setState({basicDetails:data})
	}
    render() {
        const { tabIndex, applyingFilter, sort, sort_by, assetsDetail, pageLoader, date_of_manufacture, uuid,slug,bulkOperation,basicDetails,archiveModal } = this.state;
        return (
            <section className="amp-listing-section">
                {pageLoader ? <PageLoader /> : null}
                <Grid className="mt-0" spacing={3} container>
                    <Grid className="pt-0 pr-0" xs={12} item>
                        <Box display="flex" alignItems="center">
                            <Box flexGrow={1}>
                                <ul className='list-inline'>
									<li className='list-inline-item'> <h3 className="module-heading" style={{marginTop:'6px'}}>Inventory List</h3></li>
									{smbcInstance ? null :<li className='list-inline-item'> <a href={`${config.domain.subDomian}technical-specification/${assetType[this.props?.match?.params?.assetType]}/${slug}`} target="_blank"> <h3 className="module-heading" style={{marginTop:'6px'}}><FlightIcon fontSize='small' color='primary' style={{ verticalAlign: "bottom", marginLeft: "30px" }} />Technical Specification</h3></a></li>}
									 <li className='list-inline-item export-list' > <DownloadXLSAssetDetail  files={{ title: "Master Export", extension: "xlsx", key: "" }} exportReportFn={(file) => this.exportMasterApi({ download: file.extension}, "pageLoader",this.props)} style={{color:"#bd10e0"}} /> </li>
                                </ul>
                            </Box>
                            <Box className="mr-18">
                              {smbcInstance ? null : <Link to="/dashboard">
                                    <Tooltip title="Analytics">
                                        <IconButton className="p-5px" color="primary">
                                            <PieChartOutlinedIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Link>}
                               {permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U"}) ?  <Tooltip title={this.props?.location?.search === '?archived-assets' ? 'ARCHIVE' : "ARCHIVE ASSET"}>
                                    <IconButton className="p-5px" color="primary">
                                        <Button
                                            onClick={() => this.props?.location?.search !== '?archived-assets' && this.setState({ archiveModal: true })}
                                            color={this.props?.location?.search === '?archived-assets' ? 'black' : 'primary'}
                                            size='small' variant='outlined'
                                            style={{ background: this.props?.location?.search === '?archived-assets' && 'linear-gradient(269deg, #e1e1e1, #b3b3b3)' }}>
                                            {this.props?.location?.search === '?archived-assets' ? 'ARCHIVE' : 'ARCHIVE ASSET'}
                                        </Button>
                                    </IconButton>
                                </Tooltip> : null}
                                <Tooltip title="Refresh">
                                    <IconButton
                                        className="p-5px"
                                        color="primary"
                                        onClick={this.refreshComp}
                                    >
                                        <RefreshIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Box>
                        <BasicDetailHeader props={this.props} func={this.pullData} uuid={this.uuidData}  engineType={this.engineType} module="inventory" />
                        {permissionCheckFnforCamo({
                            primaryKey: "ad_status",
                            keyIndex: "R",
                        }) ? (
                            <div className="custom-border">
                                <InventorySearchBar
                                    currentRecordPerPage={this.state.currentRecordPerPage}
                                    headerTsn={this.state.headerTsn}
                                    date_of_manufacture={date_of_manufacture}
                                    headerCsn={this.state.headerCsn}
                                    applyingFilter={applyingFilter}
                                    tabIndex={tabIndex}
                                    pageLoader={"pageLoader"}
                                    props={this.props}
                                    uuid={uuid}
                                    basicDetails={basicDetails}
                                    assetsDetail={assetsDetail.list}
                                    getResponseBack={this.refreshComp}
                                    importFile={this.importFile}
                                    fileUploadData={this.fileUploadData}
                                    searchData={(e) => this.searchResults(e.target.value)}
                                    exportReportFn={(file) => this.exportAssetDetailListFunc({download:file.extension,per_page:assetsDetail.pagination.per_page,page:assetsDetail.pagination.page , ...{ ...convertFilterObject(removeEmptyKey(applyingFilter)), asset_type: tabIndex }, }, "pageLoader")}
                                />
                                <InventoryTable
                                    currentRecordPerPage={this.state.currentRecordPerPage}
                                    heads={inventoryTableHead}
                                    sort={sort}
                                    sort_by={sort_by}
                                    bulkDeletefn={()=>this.bulkDelete(this.props,bulkOperation, assetsDetail.pagination.per_page,)}
                                    bulkOperation={bulkOperation}
                                    basicDetails={basicDetails}
                                    bulkFlag={assetsDetail?.list?.length === bulkOperation?.ids?.length && assetsDetail?.list?.length > 0}
                                    toggleBulkOps={(flag) => this.toggleBulkOps(flag, 'bulk')}
                                    data={assetsDetail.list.map((item, index) => (
                                        <InventoryList
                                           bulkOperation={bulkOperation}
                                           toggleBulkOps={(flag) => this.toggleBulkOps(flag, 'single', item)}
                                            currentRecordPerPage={this.state.currentRecordPerPage}
                                            key={index}
                                            item={item}
                                            index={index}
                                            uuid={uuid}
                                            basicDetails={basicDetails}
                                            assetsDetail={assetsDetail}
                                            getResponseBack={this.refreshComp}
                                            last_used_folder_uuid={assetsDetail.new_task_last_used_folder_uuid}
                                            last_used_folder_uuid_link_document={assetsDetail.last_used_folder_uuid_link_document}
                                            checkbox_last_used_folder_uuid={assetsDetail.checkbox_last_used_folder_uuid}
                                            checkbox_last_used_folder_name={assetsDetail.checkbox_last_used_folder_name}
                                            headerTsn={this.state.headerTsn}
                                            headerCsn={this.state.headerCsn}
                                            handleDeleteRow={(data) => this.handleDeleteRow(item, this.props, this.state.currentRecordPerPage)}
                                            updateFormData={this.updateFormData}
                                            handleEditRow={(data) => this.handleEditRow(item, this.props)}
                                            props={this.props}
                                            fileUploadData={this.fileUploadData}
                                            downloadAllApi={(file) => this.downloadAllFilesApi({ download: file.extension, ...{ ...convertFilterObject(removeEmptyKey(applyingFilter)), asset_type: tabIndex, item, }, }, "pageLoader")}
                                        />
                                    ))}
                                    createSortHandler={this.createSortHandler}
                                    pagination={assetsDetail.pagination}
                                    onChangePage={(event, newPage) => this.getInventoryListApi({ ...convertFilterObject(removeEmptyKey({ ...applyingFilter, asset_type: this.state.tabIndex, per_page: assetsDetail.pagination.per_page, page: newPage + 1, })), }, "pageLoader", this.props)}
                                    onChangeRowsPerPage={(event) =>
                                        this.setState(
                                            { currentRecordPerPage: event.target.value },
                                            () => {
                                                this.getInventoryListApi({ ...convertFilterObject(removeEmptyKey({ ...applyingFilter, asset_type: this.state.tabIndex, per_page: this.state.currentRecordPerPage, })), }, "pageLoader", this.props);
                                            }
                                        )
                                    }
                                    noRecord={assetsDetail.list.length ? null : !this.state.pageLoader ? (<EmptyCollection title="No Records Found" />) : null}
                                />
                            </div>
                        ) : (
                            <AccessDenied />
                        )}
                    </Grid>
                </Grid>
                {
                    archiveModal ?
                        <DeletePopUp
                            title='Archive Asset'
                            deleteRecordFn={() => this.onArchiveAsset(this.props, slug)}
                            modal={() => this.setState({ archiveModal: true })}
                            content='Are you sure, you want to Archive?'
                            toggleModalFn={() => this.setState({ archiveModal: false })}
                            confirmText="ARCHIVE"
                        />
                        : null
                }
            </section>
        );
    }
}
export default withSnackbar(MainInventory);